<template>
    <section class="p-6 w-full mb-32 top-0 h-screen overflow-y">
        <form-member v-if="open" :roles="roles" :edit="member"></form-member>
    </section>
</template>

<script>
export default {
    components: {},
    mounted() {
        Eventing.listen("fetchRoles", () => this.getRoles());
    },
    created() {
        this.getMember();
    },
    data() {
        return {
            member: null,
            warning: false,
            roles: [],
            open: false,
        };
    },
    methods: {
        getRoles() {
            axios
                .get("/api/modules/roles")
                .then((response) => {
                    this.roles = response.data;
                })
                .catch((error) => {});
        },

        getMember() {
            var self = this;
            axios
                .get("/api/modules/members/" + self.$route.params.id)
                .then((response) => {
                    this.member = response.data.data;
                    this.roles = response.data.roles;
                    this.open = true;
                })
                .catch((error) => {
                    // alert(error.response.status);
                });
        },
    },
};
</script>
